import { Palette } from 'src/types/whitelabel';

import { customShadows } from '../custom-shadows';
import { defaultPalette } from '../palette';

// ----------------------------------------------------------------------

export function createContrast(palette: Palette, contrast: 'default' | 'bold', mode: 'light' | 'dark') {
  const theme = {
    ...(contrast === 'bold' &&
      mode === 'light' && {
        palette: {
          background: {
            default: palette.grey[200] ?? defaultPalette.grey[200],
          },
        },
      }),
  };

  const components = {
    ...(contrast === 'bold' && {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: customShadows(palette, mode).z1,
          },
        },
      },
    }),
  };

  return {
    ...theme,
    components,
  };
}
